import { $WC } from '@/conf/common.const.js';

export default {
    /*
     * 해당 자료번호 데이터 검색
     * 삭제 여부 검색 : searchActivityYn=1
     * max데이터 목록 : searchMaxBaseColumns=col1&searchMaxBaseColumns=col2
     * 일치 검색 : where=col::val
     * 불일치 검색 : whereNot=col::val
     * LIKE 검색 : whereLike=col::val
     * 시작 LIKE : whereStartLike=col::val
     * 끝 LIKE : whereEndLike=col::val
     * 정렬: orderBy=col::asc(desc)
     */
    fetchRepoDataList(dataKdSqno, q, isIncludeFile) {
        let url = $WC.apiBaseURL + "/repos/" + dataKdSqno + "/data";
        let queryStr = q;
        if(isIncludeFile) {
            queryStr += "&isIncludeFile=true";
        }

        if(typeof queryStr !== $WC.UNDEF && queryStr !== '') {
            url += "?" + queryStr;
        }

        return axios.get(url);
    },
    // 해당 자료 번호의 데이터
    fetchRepoData(dataKdSqno, amnDataSqno, isIncludeFile) {
        let url = $WC.apiBaseURL + "/repos/" + dataKdSqno + "/data/" + amnDataSqno;
        if(isIncludeFile) {
            url += "?isIncludeFile=true";
        }

        return axios.get(url);
    },
    // 해당 자료번호 중 기준일이 가장 최근 데이터 목록
    fetchMaxBasdtValDataList(dataKdSqno) {
        let q = "searchMaxBaseColumns=basdtVal";
        return this.fetchRepoDataList(dataKdSqno, q);
    },
    // 하위데이터 검색
    fetchLowsDataList(dataKdSqno, tableColnm, sqnoColnm, basColnm, q1) {
        var q = "tableColnm="+tableColnm + "&sqnoColnm=" + sqnoColnm + "&basColnm=" + basColnm + ((q1)?'&'+q1:'');
        return axios.get($WC.apiBaseURL + '/repos/' + dataKdSqno + '/subData?' + q);
    },
    // 해당 코드 그룹의 코드 목록 가져오기
    fetchCodeListByCodeGroup(codeGroup) {
        return axios.get($WC.apiBaseURL + '/code/' + codeGroup);
    },
    // 자료종류 번호로 자료종류 정보 및 데이터 가져오기
    fetchIncludeMetaDataBySqnos(dataKdSqnos, mngTblSqno) {
        let q = "mngTblSqno=" + mngTblSqno;
        for(let i = 0; i < dataKdSqnos.length; i++) {
            q += "&dataKdSqno=" + dataKdSqnos[i];
        }
        return axios.get($WC.apiBaseURL + '/repos/includeMetaDataBySqnos?' + q);
    },
    // 뉴스 목록
    fetchNewsDataList(dataKdSqno, rflbDataSqno) {
        return axios.get($WC.apiBaseURL + '/news/' + dataKdSqno + '/' + rflbDataSqno);
    },
    // 해당 그룹 코드의 자료 종류 정보 목록
    fetchRepoListByCodeGroup(codeGroup) {
        let url = $WC.apiBaseURL + "/repos?lclasCd=" + codeGroup;
        return axios.get(url);
    },
    // 행정동 정보
    fetchSubAddongList(upKostatAddongCd) {
        let url = $WC.apiBaseURL + '/data/subAddongList/' + upKostatAddongCd;
        return axios.get(url);
    },
    // 여론동향 뉴스
    fetchNewsList(menuSqno, q) {
        let url = $WC.apiBaseURL + '/news/menuorkd/front/' + menuSqno;
        if(typeof q !== 'undefined') {
            url = url + "?" + q;
        }
        return axios.get(url);
    },
    // 카운트 검색
    fetchListCountGroupByDataKdSqno(dataKdSqno, q) {
        return axios.get($WC.apiBaseURL + '/repos/listCountGroupByDataKdSqno/' + dataKdSqno + '?' + q);
    },

    // 페이징 리스트
    fetchPageReposDataList(dataKdSqno, params) {
        let q = "";
        for(let key in params) {
            if(q != "") {
                q += "&";
            }
            if(Array.isArray(params[key])) {
                params[key].forEach(v => {
                    if(q != "") {
                        q += "&";
                    }
                    q += key + "=" + v;
                });
            } else {
                q += key + "=" + params[key];
            }
        }
        return axios.get($WC.apiBaseURL + '/repos/pageRepos/' + dataKdSqno + '?' + q);
    },

    // 항목명 포함 데이터 검색
    fetchDataKdHdngList(dataKdSqno) {
        return axios.get($WC.apiBaseURL + '/repos/retrieveDataKdHdngList/' + dataKdSqno);
    },
}
